import { PlatformUser } from './platform-user.model';

export class CurrentUser extends PlatformUser {
    token: string;
}
